import axios from 'axios';
import { getSavedState } from '../utils/localstorage';
import Vue from '../main';

export const http = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL
});



//FAZER VALIDAÇÃO PARA IDENTIFICAR CHAMADA NO ENDPOINT /AUTH,
//SE FOR O CASO, NÃO PASSAR O CABEÇALHO DE TOKEN
http.interceptors.request.use(function(config) {
  const token = getSavedState('auth.token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

http.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (
      getSavedState('auth.token') &&
      error.response &&
      error.response.status === 403
    ) {
      Vue.$store.dispatch('auth/logout');
      Vue.$router.push({
        path: '/',
        meta: {
          expiredToken: true,
        },
      });
    }else{
      return Promise.reject(error);
    }
  },
);
